import {Component, OnInit} from '@angular/core';
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {PedidoLoja} from "../../objeto/PedidoLoja";
import {ItemPedido} from "../../objeto/ItemPedido";
import {PopupUtils} from "../../objeto/PopupUtils";

/**
 * Modal aberto a partir do produto quando ele só sai agendado ("Disponível aos sábados · Agendar").
 * O cliente escolhe entrega/retirada e o dia + horário; o resultado vale para o pedido inteiro.
 * Trabalha num rascunho (itens da sacola + o produto novo) para o calendário já bloquear os dias
 * em que algum item não existe, sem mexer na sacola até confirmar.
 */
@Component({
  selector: 'app-agendar-produto',
  templateUrl: './agendar-produto.component.html',
  styleUrls: ['./agendar-produto.component.scss']
})
export class AgendarProdutoComponent implements OnInit {
  empresa: any;
  pedido: PedidoLoja;
  produto: any;
  mensagem: string;
  window: DialogRef;

  rascunho: PedidoLoja;
  formasDeEntrega: any[] = [];
  exibirAgendamento = true;
  agendarEntrega = true;

  static abraComoPopup(dialogService: DialogService, isMobile: boolean, empresa: any, pedido: PedidoLoja,
                       produto: any, mensagem: string = null): DialogRef {
    const dimensao = PopupUtils.calculeAlturaLarguraMenor(isMobile);

    const windowRef: DialogRef = dialogService.open({
      title: null,
      content: AgendarProdutoComponent,
      minWidth: 280,
      width: dimensao.largura,
      height: dimensao.altura
    });

    const tela: AgendarProdutoComponent = windowRef.content.instance;
    tela.empresa = empresa;
    tela.pedido = pedido;
    tela.produto = produto;
    tela.mensagem = mensagem;
    tela.window = windowRef;

    return windowRef;
  }

  ngOnInit(): void {
    this.formasDeEntrega = (this.empresa.formasDeEntrega || [])
      .filter((forma: any) => forma.ativa && forma.permiteAgendamento);

    this.rascunho = new PedidoLoja();
    this.rascunho.itens = [...(this.pedido.itens || []), new ItemPedido(this.produto, 1, null)];

    const formaAtual = this.formasDeEntrega.find((forma: any) => forma.nome === this.pedido.entrega.formaDeEntrega);
    if(formaAtual)
      this.rascunho.entrega.formaDeEntrega = formaAtual.nome;
    else if(this.formasDeEntrega.length === 1)
      this.rascunho.entrega.formaDeEntrega = this.formasDeEntrega[0].nome;

    // sugere a próxima data em que o produto sai (calculada pelo servidor), se serve para a sacola toda
    if(this.produto.proximaDataAgendavel) {
      const sugerida = new Date(this.produto.proximaDataAgendavel);
      sugerida.setHours(0, 0, 0, 0);
      if(!isNaN(sugerida.getTime()) && !this.rascunho.temProdutoIndisponivelNoDia(sugerida, this.empresa.catalogo))
        this.rascunho.dataEntrega = sugerida;
    }
  }

  alterouForma() {
    // recria o componente de agendamento: os limites e horários dependem da forma de entrega
    this.rascunho.horarioEntrega = null;
    this.exibirAgendamento = false;
    setTimeout(() => this.exibirAgendamento = true, 0);
  }

  podeConfirmar() {
    return !!this.rascunho.entrega.formaDeEntrega &&
      !this.rascunho.naoInformouAgendamento(this.empresa.formasDeEntrega);
  }

  confirmar() {
    if(!this.podeConfirmar()) return;

    this.window.close({
      formaDeEntrega: this.rascunho.entrega.formaDeEntrega,
      dataEntrega: this.rascunho.dataEntrega,
      horarioEntrega: this.rascunho.horarioEntrega
    });
  }

  cancelar() {
    this.window.close(null);
  }
}
